export default __webpack_public_path__ + "static/media/Sec2Icon.3ca7ee87.svg";